module.exports = __webpack_public_path__ + "static/media/staffAttendance.2cd02a3f.svg";